import styles from "./bussiness.module.css";
import { BiFolderMinus } from "react-icons/bi";
import { useState, useEffect } from "react";
import { connection } from "utils/apiConnection.ts";
import { FiEdit } from "react-icons/fi";
import { AiOutlineStop } from "react-icons/ai";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { RiDeleteBack2Line } from "react-icons/ri";
import { RiOrderPlayLine } from "react-icons/ri";
import ReactTooltip from "react-tooltip";
import Modal from "./modal/Modal";
const BoxProduct = ({
  item,
  index,
  customers,
  setSelectedItem,
  allUserTag,
  setAllUserTag,
  allLeader,
  allProductTags,
  otherInfo,
  setOtherInfo,
  setTodos
}) => {
  // console.log("item", item);
  const editHandler = () => {
    setSelectedItem(item.products__id);
    // setSelectedItem(index);
    // console.log(index);
    // console.log("custom", customers[index]);
    let optn = JSON.parse(item.available_order_option_ids);

    // console.log(optn);
    let temp = [];
    for (let i = 0; i < optn.length; i++) {
      temp.push({
        text: optn[i].default_need_time / 60,
        price: optn[i].default_price,
        user_tag_id: { value: optn[i].id, label: optn[i].title }
      });
    }
    setTodos([...temp]);

    let text = customers[index].line_id;
    const myArray = text.split(" ");
    let text2 = customers[index].sub_line_id;
    let myArray2 = "";
    if (text2 != null) {
      myArray2 = text2.split(" ");
    }

    let selectedtags = allProductTags.filter(value => {
      for (let index = 0; index < myArray.length; index++) {
        if (myArray[index] == value.value) return true;
      }
      return false;
    });
    let selectedtags2 = allProductTags.filter(value => {
      for (let index = 0; index < myArray2.length; index++) {
        if (myArray2[index] == value.value) return true;
      }
      return false;
    });
    setOtherInfo({
      products__id: item.products__id,
      title: item.title,
      path: item.path,
      main_cover_file_id: item.main_cover_file_id,
      line_id: [...selectedtags],
      sub_line_id: [...selectedtags2],
      cat_id: item.cat_id,
      description: item.description,
      default_price: item.default_price,
      default_weight_from: item.default_weight_from,
      default_weight_to: item.default_weight_to,
      sum_product_rate: item.sum_product_rate,
      count_product_rate: item.count_product_rate,
      total_inventory: item.total_inventory,
      total_supplier_count: item.total_supplier_count,
      best_supplier_id: item.best_supplier_id

      // products__id: customers[index].products__id,
      // title: customers[index].title,
      // path: customers[index].path,
      // main_cover_file_id: customers[index].main_cover_file_id,
      // line_id: [...selectedtags],
      // sub_line_id: [...selectedtags2],
      // cat_id: customers[index].cat_id,
      // description: customers[index].description,
      // default_price: customers[index].default_price,
      // default_weight_from: customers[index].default_weight_from,
      // default_weight_to: customers[index].default_weight_to,
      // sum_product_rate: customers[index].sum_product_rate,
      // count_product_rate: customers[index].count_product_rate,
      // total_inventory: customers[index].total_inventory,
      // total_supplier_count: customers[index].total_supplier_count,
    });
  };
  const stopHandler = () => {
    setSelectedItem(item.products__id);
    // setSelectedItem(index);
    console.log(index);
  };
  const showLine = () => {
    let b =
      allProductTags.length > 0 &&
      allProductTags.find(a => a.value == item.line_id);

    return <>{b.label}</>;
  };

  // console.log("item", item);
  // console.log("allProductTags", allProductTags);
  return (
    <div
      className={`  w-100  ${styles.sec}`}
      style={{
        borderRadius: " 10px"
      }}
    >
      <div className={`d-flex flex-wrap ${styles.secondry}`}>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عنوان
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.title}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            توضیحات
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.description}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تصویر
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            <img
              style={{
                width: "55px",
                borderRadius: "50%",
                height: "50px",
                marginTop: "5px"
              }}
              src={`http://sabadi.tatdemo.ir/${item.path}`}
            />
          </div>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            لاین محصول
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {showLine()}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد سفارشات
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {addCommas(item.count_product_rate)}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            قیمت واحد
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {addCommas(item.default_price)}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد فروشگاه هایی که موجود دارند
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {addCommas(item.sum_product_rate)}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            کل موجودی
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {addCommas(item.total_inventory)}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد اضافه به سبد خرید
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {addCommas(item.total_supplier_count)}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عملیات{" "}
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModalEditProduct`}
              onClick={editHandler}
            >
              <h4 data-tip="ویرایش محصول">
                <FiEdit className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#deleteProductModal`}
              onClick={stopHandler}
            >
              <h4 data-tip="حذف محصول">
                <RiDeleteBack2Line className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#stopProductModal`}
              onClick={stopHandler}
            >
              <h4 data-tip="توقف محصول">
                <AiOutlineStop className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxProduct;
